import { EventEmitter, Inject, Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  CriteriaQuery,
} from "@fpx/core";
import { BehaviorSubject, map } from "rxjs";
import { PfmspendsService } from '../pfmspends-service/pfmspends.service';
import { Pfmspends } from '../pfmspends-service/pfmspends.model';
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PfmMainService } from "../services/pfm-main.service";
import moment from "moment";




export class PfmCategoryDetailsFormState extends BaseFpxComponentState {
 	showSuggestion : boolean = false;
   pfmCategoryDetails;
   swipeCoord;
   swipeTime;
   selectedTab=0;
   refreshCriteria$: BehaviorSubject<CriteriaQuery> = new BehaviorSubject<CriteriaQuery>(null);
  currentPfmSpendDate: any;
  isCategoryHistoryEmpty: boolean;
  isInsightChartEmpty: boolean;


}


@Injectable()
export class PfmCategoryDetailsFormHelper extends BaseFpxFormHelper<PfmCategoryDetailsFormState>{

   constructor(public pfmMainService:PfmMainService, private pfmCategoryDetailsFormService: PfmspendsService,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData)
    {
        super(new PfmCategoryDetailsFormState());
    }

  override doPreInit(): void {
    this.pfmMainService.selectedpfmCategoryData = this.data?.screenData?.data;

    let date = this.pfmMainService.currentPfmSpendDate?.split("/");

    this.state.currentPfmSpendDate = this.getFullMonth(date[1])+" "+date[2];
  }

  getFullMonth(index){

    let month = [
      "January",
      "February",
      "March ",
      "April ",
      "May ",
      "June ",
      "July ",
      "August ",
      "September ",
      "October ",
      "November ",
      "December",
    ]
    return month[parseInt(index)-1];
  }

  public override doPostInit(): void {
    // const criteriaQuery = new CriteriaQuery();
    // criteriaQuery.addQueryparam('categoryCode', this.state.pfmCategoryDetails.categoryCode);
    // this.state.refreshCriteria$.next(criteriaQuery);

    this.pfmMainService.pfmcategoryHistoryEmit = new EventEmitter<any>();
    this.pfmMainService.pfmcategoryHistoryEmit.subscribe((element) => {
      if(element && element.length>0){
        this.state.isCategoryHistoryEmpty = false;
      }else{
        this.state.isCategoryHistoryEmpty = true;
      }
    })

    this.pfmMainService.pfmInsightChartEmit = new EventEmitter<any>();
    this.pfmMainService.pfmInsightChartEmit.subscribe((element) => {
      if(element && element.length>0){
        this.state.isInsightChartEmpty = false;
      }else{
        this.state.isInsightChartEmpty = true;
      }
    })

  }

  public doDestroy(): void {
    this.pfmMainService.pfmcategoryHistoryEmit.unsubscribe();
    this.pfmMainService.pfmInsightChartEmit.unsubscribe();
  }


  public override preSubmitInterceptor(payload: Pfmspends):any {
     // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response:any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
 //$START_CUSTOMSCRIPT\n
 //starts action when user swipes
 swipe(e: TouchEvent, when: string): void {
  try {
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();
    if (when === 'start') {
      this.state.swipeCoord = coord;
      this.state.swipeTime = time;
    } else if (when === 'end') {
      const direction = [coord[0] - this.state.swipeCoord[0], coord[1] - this.state.swipeCoord[1]];
      const duration = time - this.state.swipeTime;
      if (duration < 1000 //
        && Math.abs(direction[0]) > 30 // Long enough
        && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        console.info(swipe);
        if (swipe === 'next') {
          const isFirst = this.state.selectedTab === 0;
          if (this.state.selectedTab <= 3) {
            this.state.selectedTab = isFirst ? 1 : this.state.selectedTab + 1;
          }
          console.log("Swipe left ? INDEX: " + this.state.selectedTab);
        } else if (swipe === 'previous') {
          const isLast = this.state.selectedTab === 4;
          if (this.state.selectedTab >= 1) {
            this.state.selectedTab = this.state.selectedTab - 1;
          }
          console.log("Swipe right ? INDEX: " + this.state.selectedTab);
        }
        // Do whatever you want with swipe
      }
    }
  } catch (err) {

  }
}
tabChanged(event){

}
 //$END_CUSTOMSCRIPT\n
}
